import { server_connection } from 'config';
import { SET_USER_DATA } from '../actions/user.actions';
import store from 'store';
import * as CompanyActions from '../../../main/content/company/store/actions';
import * as StudentActions from '../../../main/content/student/store/actions';
import * as InstructorActions from '../../../main/content/instructor/store/actions';

export const GET_AUTH_LIST = 'GET AUTH LIST';
export const GET_AUTH = 'GET AUTH';
export const UPDATE_AUTH_LOADED = 'UPDATE AUTH LOADED';
export const GET_AUTH_DATA = 'GET AUTH DATA';
export const UPDATE_AUTH_FORM = 'UPDATE AUTH FORM';
export const UPDATE_AUTH_COMPANIES = 'UPDATE AUTH COMPANIES';
export const UPDATE_AUTH_ROLE = 'UPDATE AUTH ROLE';
export const PRELOAD_COMPANY = 'PRELOAD COMPANY';
export const GET_AUTH_ACTIVITY_LIST = 'GET AUTH ACTIVITY LIST';
export const DROP_COMPANY = 'DROP COMPANY'

export function updateAuthLoaded(setting) {
    return {
        type: UPDATE_AUTH_LOADED,
        payload: setting
    }
}

export function getAuthList() {
    return (dispatch, getState) => {
        fetch(server_connection + '/auth/list')
            .then((response) => response.json())
            .then((data) => {
                dispatch({
                    type: GET_AUTH_LIST,
                    payload: data,
                });
            });
    }
}

export function getAuth(auth_id) {
    return async (dispatch, getState) => {
        await fetch(server_connection + '/auth/get_user_by_auth_id/' + auth_id)
            .then((response) => response.json())
            .then((data) => {
                dispatch({
                    type: GET_AUTH,
                    payload: data,
                });
            });
    }
}

export function getAuthActivity(auth_id) {
    return async (dispatch, getState) => {
        await fetch(server_connection + '/auth/action_log_list',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ auth_id })
            })
            .then((response) => response.json())
            .then((responseData) => {
                dispatch({
                    type: GET_AUTH_ACTIVITY_LIST,
                    payload: responseData,
                });
            });
    }
}

export function getAuthData(auth_id, company_id) {
    return dispatch =>
        Promise.all([
            dispatch(getAuth(auth_id)),
            dispatch(getAuthActivity(auth_id))
        ]).then(() => {
            dispatch(updateAuthLoaded(true));
            dispatch(preloadCompany(company_id));
        })
}

export function preloadCompany(company_id) {
    return {
        type: PRELOAD_COMPANY,
        payload: company_id
    }
}

export function rePullAuthData(auth_id) {
    return async (dispatch, getState) => {
        await fetch(server_connection + '/auth/pull_auth_data/' + auth_id)
            .then((response) => response.json())
            .then((responseData) => {
                dispatch({
                    type: SET_USER_DATA,
                    payload: responseData
                })
            })
    }
}

export function saveAuth(auth, deleted_roles, companyInfo) {
    const currentLoggenInUser = store.getState().auth;
    const current_auth_id = currentLoggenInUser.user.data.auth_id
    const newAuth = {
        ...auth,
        extras: {
            active_user_id: current_auth_id,
            qualification_list: [],
            company_list: []
        }
    }
    return async (dispatch, getState) => {
        await fetch(server_connection + '/auth/save',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ auth: newAuth, deleted_roles: deleted_roles, companyInfo })
            })
            .then((response) => response.json())
            .then((responseData) => {
                dispatch(getAuthList());
                const paramHistory = store.getState().paramHistory;
                if (current_auth_id === auth.auth_id) {
                    dispatch(rePullAuthData(current_auth_id));
                }

                if (paramHistory.companyAuth.active) {
                    dispatch(CompanyActions.getCompanyAuthList(paramHistory.companyAuth.company_id))
                }

                if (paramHistory.authPreloadRole.active && paramHistory.authPreloadRole.role.RoleName === 'Student') {
                    dispatch(StudentActions.getStudentList())
                }

                if (paramHistory.authPreloadRole.active && paramHistory.authPreloadRole.role.RoleName === 'Instructor') {
                    dispatch(InstructorActions.getInstructorList())
                }
            });
    }
}

export function updateAuthForm(auth_data) {
    return {
        type: UPDATE_AUTH_FORM,
        payload: auth_data
    }
}

export function updateAuthRole(role, action_type) {
    return {
        type: UPDATE_AUTH_ROLE,
        payload: { role, action_type }
    }
}

export function deactivateAuth(auth_id) {
    return (dispatch, getState) => {
        fetch(server_connection + '/auth/deactivate/' + auth_id)
            .then((response) => response.json())
            .then((responseData) => {
                dispatch(getAuthList());
            });
    }
}

export function activateAuth(auth) {
    return async (dispatch, getState) => {
        await fetch(server_connection + '/auth/activate',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ auth: auth })
            })
            .then((response) => response.json())
            .then((responseData) => {
                dispatch(getAuthList());
            });
    }
}

export function deleteAuth(auth_id) {
    return (dispatch, getState) => {
        fetch(server_connection + '/auth/delete/' + auth_id)
            .then((response) => response.json())
            .then((responseData) => {
                dispatch(getAuthList());
                if (store.getState().paramHistory.companyAuth.active) {
                    dispatch(CompanyActions.getCompanyAuthList(store.getState().paramHistory.companyAuth.company_id))
                }
            });
    }
}

export function updateAuthCompanies(data) {
    return {
        type: UPDATE_AUTH_COMPANIES,
        payload: data
    }
}

export function dropCompany(data) {
    return {
        type: DROP_COMPANY,
        payload: data
    }
}



// WEBPACK FOOTER //
// src/auth/store/actions/crud.actions.js